<template>
    <router-link to="/karriere/stellenangebote#top-of-page" class="global-m">
        <img :src="getImage('global-m.svg')" alt="">
    </router-link>
</template>
<script>
export default {};
</script>